// Date helpers shared across features. Values are plain YYYY-MM-DD strings (the
// format used by <input type="date">), and arithmetic is done in UTC so results
// never drift by a day across time zones.

/** The LDG delivery milestone sits this many days before the aircraft induction date. */
export const LDG_OFFSET_DAYS = 10;

/**
 * Subtract whole days from a YYYY-MM-DD string, computed in UTC.
 * Returns '' for blank or malformed input.
 */
export const subtractDays = (isoDate: string, days: number): string => {
  if (!isoDate) return '';
  const parts = isoDate.split('-').map((part) => Number(part));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return '';
  const [year, month, day] = parts;
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() - days);
  const yyyy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Resolve a record's LDG induction date: the stored value when present, otherwise
 * derived from the aircraft induction date (for records saved before the field
 * existed). Returns '' when neither is available.
 */
export const resolveLdgInductionDate = (ldgInductionDate: string, inductionDate: string): string =>
  ldgInductionDate || subtractDays(inductionDate, LDG_OFFSET_DAYS);
